import React from 'react'
import { Container, Flex, FlexItem } from '@quark/layout'
import { Text } from '@quark/typography'
import { Layer } from '@quark/layer'
import { ChevronRight } from '@quark/icons'

const UserStory = () => (
  <div
    style={{ width: '600px', height: '200px', cursor: 'pointer' }}
    onClick={() => {
      window.open('/reviews-testimonials/', '_blank')
    }}>
    <Container
      borderRadius="radius-2xl"
      type="max-parent"
      overflow="hidden"
      backgroundColor="static/Black/100"
      boxShadow="Coloured FX/Small">
      <Flex alignItems="center" justifyContent="space-between" size="fullHeight">
        <FlexItem grow>
          <Container paddingLeft="spacing-20" paddingTop="spacing-20" paddingBottom="spacing-20">
            <Flex gap="spacing-8" flexDirection="column">
              <div>
                <Text fontStyle="um_text-xl/bold" color="static/Primary-onDark">
                  Stories that
                </Text>
                <br />
                <Text fontStyle="um_text-xl/bold" color="static/Primary-onDark">
                  speak for ACKO
                </Text>
              </div>
              <Flex alignItems="center" gap="spacing-2">
                <Text fontStyle="um_text-base/bold" color="static/Primary-onDark">
                  Know more{' '}
                </Text>
                <Text fontStyle="um_text-lg/bold" color="static/Primary-onDark" lineHeight="line-height-0">
                  <ChevronRight color="static/Primary-onDark" />
                </Text>
              </Flex>
            </Flex>
          </Container>
        </FlexItem>
        <FlexItem>
          <div style={{ width: '186px', height: '200px' }}>
            <Container type="max-parent">
              <Layer
                imgMd="https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Tesimonial_Vd_thumbnail_1_bc5526b92a.webp"
                imgLg="https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Tesimonial_Vd_thumbnail_1_bc5526b92a.webp">
                {' '}
              </Layer>
            </Container>
          </div>
        </FlexItem>
      </Flex>
    </Container>
  </div>
)

export default UserStory
